import { render, staticRenderFns } from "./PagamentoDesassociarComprometimento.vue?vue&type=template&id=47bc2e2a&"
import script from "./PagamentoDesassociarComprometimento.vue?vue&type=script&lang=js&"
export * from "./PagamentoDesassociarComprometimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports